import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatBubbleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.9 11.2Q1.7 9.7 1.6 7.6c0-3.3 2.9-6 6.4-6s6.4 2.7 6.4 6-2.9 6-6.4 6q-1.4 0-2.6-.5l-2.9 1.2-.3.1a.6.6 0 0 1-.5-1zm1-.7q.4.6 0 1.3l-.4.8L5 12h.9q.9.4 2.1.4c3 0 5.2-2.2 5.2-4.8S10.9 2.8 8 2.8 2.8 5 2.8 7.6q0 1.5 1 2.9" })
});
export default SvgChatBubbleRegularIcon;
